/*
 * cm-modal — generic open/close wiring for <dialog>-based popups.
 *
 * Any [data-cm-modal-open="key"] button opens the [data-cm-modal="key"]
 * dialog; a [data-cm-modal-close] button or a click on the dialog's own
 * backdrop closes it. One small script instead of writing this same
 * three-line binding into every snippet that needs a popup.
 */
(() => {
  const bindOpeners = () => {
    document.querySelectorAll('[data-cm-modal-open]').forEach((btn) => {
      if (btn.dataset.cmModalBound) return;
      btn.dataset.cmModalBound = 'true';
      btn.addEventListener('click', () => {
        const dialog = document.querySelector(`[data-cm-modal="${btn.dataset.cmModalOpen}"]`);
        if (dialog) dialog.showModal();
      });
    });

    document.querySelectorAll('[data-cm-modal]').forEach((dialog) => {
      if (dialog.dataset.cmModalBound) return;
      dialog.dataset.cmModalBound = 'true';
      const closeBtn = dialog.querySelector('[data-cm-modal-close]');
      if (closeBtn) closeBtn.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindOpeners);
  } else {
    bindOpeners();
  }
})();
